import React from 'react';

interface Props {
  value: string;
  onChange: (value: string) => void;
}

/**
 * Free-text "who referred you?" input shown at checkout for SOCIAL events.
 * Optional — the answer is stored as-is on the registration for later attribution.
 */
export default function ReferralQuestion({ value, onChange }: Props) {
  return (
    <div className="mt-6">
      <label htmlFor="referred-by" className="typography-product-subheading mb-ds-lg block">
        Were you referred by someone? <span className="font-normal">(optional)</span>
      </label>
      <input
        id="referred-by"
        name="referredBy"
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Let us know who sent you"
        maxLength={500}
        className="input-form w-full"
      />
    </div>
  );
}
